(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const containers = document.querySelectorAll('.snow-container');
  if (!containers.length) return;

  const isMobile = window.innerWidth < 768;
  const FLAKE_COUNT = isMobile ? 30 : 70;

  containers.forEach(container => {

  function createFlake() {
    const flake = document.createElement('div');
    flake.className = 'snowflake';

    // ⛄ Bigger snow size
    const size = Math.random() * (isMobile ? 3 : 4) + 5;
    flake.style.width = size + 'px';
    flake.style.height = size + 'px';

    // Random horizontal start
    flake.style.left = Math.random() * 100 + 'vw';

    // ⚡ Faster falling speed
    flake.style.animationDuration =
      (Math.random() * (isMobile ? 2 : 3) + 4) + 's, ' +
      (Math.random() * 2 + 3) + 's';


    flake.style.animationDelay =
      (Math.random() * 0) + 's, 0s';

    // 🌬 Random air sway distance
    const sway = Math.random() * (isMobile ? 15 : 30) - 15;
    flake.style.setProperty('--sway', sway + 'px');

    flake.style.opacity = Math.random() * 0.5 + 0.5;

    return flake;
  }

  for (let i = 0; i < FLAKE_COUNT; i++) {
    container.appendChild(createFlake());
  }

});
})();
